import { buildNonMonetaryDetailSheet, toRows } from "./principle1DetailHelpers";

export const SHEET_NAME = "Imprisonment";

export function buildImprisonmentSheet(workbook, sectionC) {
  const essential = sectionC?.principle1?.essentialIndicators || {};
  return buildNonMonetaryDetailSheet(
    workbook,
    SHEET_NAME,
    "Details of imprisonment",
    toRows(essential?.nonMonetary?.imprisonment)
  );
}
